export const amplitudeAction = {
  TRANSFER_SEND: 'Transfer Send Funnel',
};
